export const setTempWishListMenuAction = (menuId, isWishList) => {
    return {
        type: 'SET_TEMP_WISH_LIST_MENU',
        isWishList,
        menuId
    }
}